import API_BACK from "../lib/axiosBack";
// import API from "../lib/axios";
interface WithdrawalPayload {
  cryptoAddress: string;
  network: string;
  amount: string;
}

export const requestWithdrawal = async ({
  cryptoAddress,
  network,
  amount,
}: WithdrawalPayload): Promise<void> => {
  const payload = {
    cryptoCurrency: "USDT",
    cryptoAddress,
    network,
    amount,
  };

  await API_BACK.post("/withdrawals/external/withdrawal-request", payload);
  // await API.post("/back/withdrawals/external/withdrawal-request", payload);
};
